import React from 'react'
import pure from 'recompose/pure'
import injectSheet from 'react-jss'
import colors from 'aria-viewer/tour/constants/style/colors'
import styleGuide from 'aria-viewer/tour/constants/styleGuide'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import { connect } from 'react-redux'
import { actionButtonClicked } from 'aria-viewer/analytics/analyticActions'

import { PROMPT_ACTION_BUTTON_INDEX } from 'aria-viewer/keyboard/constants/tabIndices'

const IndexColors = ['YELLOW', 'GREEN', 'BLUE']

const BackgroundImgs = {
    YELLOW: 'linear-gradient(246deg, #ecc500, #ffab00)',
    GREEN: 'linear-gradient(251deg, #00b849, #04b730)',
    BLUE: 'linear-gradient(254deg, #00cdff, #1eb0fc)',
}

const styleSheet = {
    anchor: {
        cursor: 'pointer',
    },
    container: {
        backgroundImage: ({ index }) => {
            // look up the proper gradient for the action button
            if (index <= 2) {
                return BackgroundImgs[IndexColors[index]]
            }
            if (index > 2) {
                throw new Error('CTAButton.props.index > 2')
            }
        },
        boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.5)',
        color: colors.white,
        padding: ({ isDeviceMobile }) => (isDeviceMobile ? '1.25em' : '1em') + ' 2.25em',
        textAlign: 'center',
        whiteSpace: 'nowrap',
        textTransform: 'uppercase',
        borderRadius: '4px',
        width: ({ viewportWidth, isDeviceMobile }) => {
            if (isDeviceMobile) {
                return viewportWidth <= 320 ? '10.75em' : '11.75em'
            } else {
                return '7.5em'
            }
        },
        marginTop: ({ isDeviceMobile }) => (isDeviceMobile ? '1.8em' : '1.3em'),
        marginBottom: ({ isDeviceMobile }) => (isDeviceMobile ? '1.8em' : '1.3em'),
    },
    childrenContainer: {
        fontWeight: styleGuide.fonts.normal,
        fontSize: ({ viewportWidth, isDeviceMobile }) => {
            if (isDeviceMobile) {
                return viewportWidth <= 320 ? '17px' : '18px'
            } else {
                return '15px'
            }
        },
    },
}

const CTAButton = pure(
    injectSheet(styleSheet)(function CTAButton({
        classes,
        index,
        action,
        domId,
        onClick,
        client,
        children,
        actionButtonClicked,
    }) {
        const { actionid, name, color, analyticsAction, url } = action

        /* Adding #yvexternal will force the mobile app to open in System browser. */
        const actionURL = url && client.isClientApp ? url + '#yvexternal' : url

        const onClickEvent = e => {
            actionButtonClicked({
                action: analyticsAction,
                color: color || styleGuide.buttons[actionid].actionColor,
                name,
            })

            onClick && onClick(e)
        }

        return (
            <a
                className={classes.anchor}
                tabIndex={PROMPT_ACTION_BUTTON_INDEX}
                href={actionURL}
                id={domId || `action_${actionid}`}
                target="_blank"
                onClick={onClickEvent}
                alt={children}
            >
                <div className={classes.container}>
                    <div className={classes.childrenContainer}>{children}</div>
                </div>
            </a>
        )
    })
)

export default connect(
    mapSelectorsToProps(['client', 'viewportWidth', 'viewportHeight', 'isDeviceMobile']),
    { actionButtonClicked }
)(CTAButton)
